import 'core-js/modules/es.symbol.js';
import 'core-js/modules/es.symbol.description.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.string.link.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';
import classNames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';
import '../../tokens/color-tokens/index.js';
import '../../tokens/elevation-tokens/index.js';
import { Heading, Body } from '../../tokens/typography/typography.js';
import { Flex } from '../flex/flex.js';
import 'tslib';
import { Link } from '../link/link.js';

/**
 *
 *
 * Help avoid confusion when information or data is not available
 * Empty states should help the user understand why information or data is missing, helping them avoid confusion.
 *
 * [Open docs »](https://cognitedata.github.io/cogs.js/storybook/?path=/docs/core_core-emptystate--docs)
 *
 *
 * [Read the full documentation »](https://zeroheight.com/37d494d9d/p/85d095-empty-states/b/4701cc)
 */
var EmptyState = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    style = _ref.style,
    title = _ref.title,
    description = _ref.description,
    illustration = _ref.illustration,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? 'medium' : _ref$size,
    primaryAction = _ref.primaryAction,
    secondaryAction = _ref.secondaryAction,
    helpText = _ref.helpText,
    themeProps = _ref.themeProps,
    error = _ref.error;
  return jsxs("div", {
    ref: ref,
    "data-testid": "cogs-empty-state",
    className: classNames.apply(undefined, ['cogs-v10'].concat(getThemeClassNames(undefined, themeProps), ['cogs-empty-state', "cogs-empty-state--size-" + size, className])),
    style: style,
    children: [jsx("div", {
      className: "cogs-v10 cogs-empty-state__illustration-container",
      children: illustration
    }), jsxs(Flex, {
      direction: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: size === 'small' ? 2 : 4,
      className: "cogs-v10 cogs-empty-state__text-container",
      children: [title && jsx(Heading, {
        level: size === 'small' ? 6 : 4,
        children: title
      }), description && jsx(Body, {
        className: "cogs-v10 cogs-empty-state__text-container__description",
        size: "medium",
        children: description
      })]
    }), error && jsx(Flex, {
      direction: "column",
      className: "cogs-v10 cogs-empty-state__error",
      alignItems: "center",
      children: jsx(Body, {
        size: "x-small",
        muted: true,
        children: error
      })
    }), (secondaryAction || primaryAction) && jsxs(Flex, {
      gap: 8,
      className: "cogs-v10 cogs-empty-state__actions",
      children: [secondaryAction, primaryAction]
    }), helpText && jsxs(Flex, {
      gap: 8,
      "data-testid": "empty-state-help-text",
      alignItems: "center",
      className: "cogs-v10 cogs-empty-state__help-text",
      children: [(helpText === null || helpText === undefined ? undefined : helpText.text) && jsx(Body, {
        muted: true,
        size: "medium",
        children: helpText.text
      }), (helpText === null || helpText === undefined ? undefined : helpText.link) && jsx(Link, Object.assign({}, helpText.link))]
    })]
  });
});

export { EmptyState };
